import React from 'react';
import { Link, Meta, Title } from 'react-head';
import { origin } from '../../config';
import { translate } from '../../utils/locale';
import { urlify } from '../../utils/string';

const Top = ({ setup, pageContent, paths, locationType, skipGeneral = false }) => {
	if (!pageContent) return null;
	const metaInfo = { ...pageContent };
	const titlePrefix = translate(setup, 'titlePrefix', 'meta');
	const titleSuffix = translate(setup, 'titleSuffix', 'meta');
	const tags = {};

	Object.keys(metaInfo).forEach((tag) => {
		const text = translate(setup, metaInfo[tag]);
		if (tag.indexOf('meta') === 0 && text !== '') {
			tags[tag] = <Meta key={tag} name={tag.replace('meta', '').toLowerCase()} content={text} />;
		} else if (tag.indexOf('link') === 0) {
			tags[tag] = <Link key={tag} rel={tag.replace('link', '').toLowerCase()} href={text} />;
		}
	});

	if (paths && Object.keys(paths).length > 1) {
		Object.keys(paths).forEach((lang) => {
			// News exists but is not that page.
			if (paths[lang] && ((paths[lang].indexOf('new-arrivals') !== -1 && paths[lang] !== 'new-arrivals') || (paths[lang].indexOf('nyinkommet') !== -1 && paths[lang] !== 'nyinkommet'))) {
				tags.metaRobots = <Meta key="metaRobots" name="robots" content="noindex" />;
			}
			if (paths[lang] === '' || paths[lang] === 'start' || locationType === 'START') {
				tags[`linkAlternate${lang}`] = <Link key={`linkAlternate${lang}`} rel="alternate" hrefLang={lang} href={`${origin}/${lang}`} />;
			} else if (!metaInfo.restrict || (metaInfo.restrict && metaInfo.restrict.indexOf(lang) === -1)) {
				tags[`linkAlternate${lang}`] = <Link key={`linkAlternate${lang}`} rel="alternate" hrefLang={lang} href={`${origin}/${lang}/${paths[lang]}`} />;
			}
		});
	}
	const metaDescription = metaInfo.metaDescription ? metaInfo.metaDescription : setup.meta.defaultMetaDescription;
	if (metaInfo.title && !metaInfo.title.text) metaInfo.title = { text: metaInfo.title };
	const title = `${skipGeneral || titlePrefix === 'titlePrefix' ? '' : `${titlePrefix} `}${metaInfo.title ? translate(setup, metaInfo.title) : ''}${skipGeneral || titleSuffix === 'titleSuffix' ? '' : ` ${titleSuffix}`}`;

	tags['og:type'] = <Meta key="ogType" property="og:type" content="website" />;
	tags['og:title'] = <Meta key="ogTitle" property="og:title" content={title} />;
	tags['og:description'] = <Meta key="ogDescription" property="og:description" content={translate(setup, metaDescription)} />;
	if (metaInfo.image) tags['og:image'] = <Meta key={`ogImage-${urlify(metaInfo.image.url.slice(metaInfo.image.url.lastIndexOf('/')))}`} property="og:image" content={metaInfo.image.url} />;
	else if (metaInfo.images) tags['og:image'] = metaInfo.images.map((image) => <Meta key={`ogImage-${urlify(image.slice(image.lastIndexOf('/')))}`} name={`ogImage-${urlify(image.slice(image.lastIndexOf('/')))}`} property="og:image" content={image} />);

	const canonical = metaInfo.canonical || metaInfo.linkCanonical;
	if (canonical) tags['og:url'] = <Meta key="ogUrl" property="og:url" content={canonical} />;


	return (
		<div>
			<Title>{ title }</Title>
			{
				Object.keys(tags).map((tag) => {
					if (tag === 'metaDescription') return <Meta key="metaDescription" name="description" content={translate(setup, metaDescription)} />;
					return tags[tag];
				})
			}
		</div>
	);
};

export default Top;
